// Footer.js
import './footer.css';

function Footer() {
    return (
        <section className="footer">
            <div className="f_container">
                <div className="f_contact-info">
                    <div className="f_support">
                        Наші Контакти:
                    </div>
                    <div>
                        +38 063 402 81 02
                    </div>
                    <div className="email">
                        <a href="mailto:airlinklviv@gmail.com">
                            <i className="far fa-envelope"/>
                            <span>airlinklviv@gmail.com</span>
                        </a>
                    </div>
                </div>
                <div className="f_socials">
                    <ul>
                        <li>
                            <a href="https://www.facebook.com/profile.php?id=61554732366481" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-facebook-f"/>
                                <span> - Facebook</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/AirLink4826" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-twitter"/>
                                <span> - Twitter</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://tiktok.com/@airlinklviv" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-tiktok"/>
                                <span> - TikTok</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.linkedin.com/in/air-link-2145002a6/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-linkedin"/>
                                <span> - LinkedIn</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default Footer;
